import { action } from 'satcheljs';
import type { WindowKey } from 'owa-bizchat-types';

export interface OnCopilotChatDrawerClosedMessage {
    // Whether the action is triggered programmatically or by user interaction.
    isProgrammatic: boolean;
    // The window key identifying which window the drawer was closed in.
    windowKey: WindowKey;
}
export const onCopilotChatDrawerClosed: (
    isProgrammatic: boolean,
    windowKey: WindowKey
) => OnCopilotChatDrawerClosedMessage = action(
    'onCopilotChatDrawerClosed',
    (isProgrammatic: boolean, windowKey: WindowKey): OnCopilotChatDrawerClosedMessage => ({
        isProgrammatic,
        windowKey,
    })
);
